import { sanitizeHtml } from '@/utils/sanitizeHtml'

export default defineNuxtPlugin((nuxtApp) => {
  const setInnerHtml = (el, value) => {
    el.innerHTML = sanitizeHtml(value)
  }

  nuxtApp.vueApp.directive('safe-html', {
    beforeMount(el, binding) {
      setInnerHtml(el, binding.value)
    },
    updated(el, binding) {
      if (binding.value !== binding.oldValue) {
        setInnerHtml(el, binding.value)
      }
    },
    getSSRProps(binding) {
      return {
        innerHTML: sanitizeHtml(binding.value),
      }
    },
  })
})
